import { render, staticRenderFns } from "./DvSkeleton.vue?vue&type=template&id=fd5250a8&scoped=true&"
import script from "./DvSkeleton.vue?vue&type=script&lang=ts&"
export * from "./DvSkeleton.vue?vue&type=script&lang=ts&"
import style0 from "./DvSkeleton.vue?vue&type=style&index=0&id=fd5250a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5250a8",
  null
  
)

export default component.exports